import { useGetReviewerPermissions } from './use-get-reviewer-permissions';

type ReviewerRole = 'supervisor' | 'firstTierReviewer' | 'secondTierReviewer';

export function useGetReviewerPermissionRoles() {
  const { view, update } = useGetReviewerPermissions();

  // ------ Determine Reviewer Role ------
  const roles: Set<ReviewerRole> = new Set();
  if (view.supervisor || update.supervisor) {
    roles.add('supervisor');
  }
  if (view.firstTierReviewer || update.firstTierReviewer) {
    roles.add('firstTierReviewer');
  }
  if (view.secondTierReviewer || update.secondTierReviewer) {
    roles.add('secondTierReviewer');
  }

  return {
    roles,
  };
}
